export default "__VITE_ASSET__2Fvcd3tJ__"